import http from './http'

export function getPositions(userId, accessToken, isOpen) {
	return http({
		method: 'GET',
		url: `/rest/trades?filter[user]=${userId}${isOpen ? '&filter[status]=open' : ''}&access_token=${accessToken}`
	})
}
export function getNews(language, alias) {
	return http({
		method: 'GET',
		url: `/rest/asset/rss?lang=${language}${alias ? '&alias='+ alias : ''}`
	})
}

export function getMarginCall(data) {
	return http({
		data,
		method: 'POST',
		url: '/rest/rest_post_trades_margincall'
	})
}
export function refreshTrade(tradeId) {
	return http({
		method: 'GET',
		url: '/refresh/trade/' + tradeId
	})
}
